import React, { useCallback } from 'react';
import { Formik } from 'formik';
import { FieldNumber } from '../components/FieldNumber';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import classnames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
  },
  childrenContainer: {
    flexGrow: 1,
  },
  numberContainer: {
    position: 'relative',
    left: -theme.marginBase * 2,
  },
  withNumberChildrenContainer: {
    marginLeft: -theme.marginBase,
  },
}));
interface Props {
  fieldNumber?: number;
  children: React.ReactNode;
}

const initialValues = {
  type: 'text',
  field: {},
};

export const PreviewFieldForm = ({ fieldNumber, children }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  const onSubmit = useCallback(() => {}, []);
  return (
    <Formik onSubmit={onSubmit} initialValues={initialValues}>
      <div className={classes.container}>
        <div className={classes.numberContainer}>
          {fieldNumber && <FieldNumber number={fieldNumber} />}
        </div>
        <div
          className={classnames(
            classes.childrenContainer,
            fieldNumber && classes.withNumberChildrenContainer,
          )}
        >
          {children}
        </div>
      </div>
    </Formik>
  );
};
